const NICE_FACTORS = [1, 2, 2.5, 5] as const

/**
 * A tidy axis for `maxValue`: the smallest step of 1, 2, 2.5 or 5 times a power of ten that needs
 * no more than `ticks + 1` intervals, and the top tick that covers the data.
 */
export function niceScale(maxValue: number, ticks = 4): { step: number; max: number } {
  if (maxValue <= 0) return { step: 1, max: 1 }
  const start = Math.floor(Math.log10(maxValue / ticks)) - 1
  for (let exp = start; exp < start + 12; exp += 1) {
    for (const factor of NICE_FACTORS) {
      const step = factor * Math.pow(10, exp)
      if (Math.ceil(maxValue / step - 1e-9) <= ticks + 1) {
        return { step, max: Math.ceil(maxValue / step - 1e-9) * step }
      }
    }
  }
  return { step: maxValue, max: maxValue }
}

/** Ist of Soll as the colour the Arbeitszeit-Report uses for Auslastung: over 100 red, under 70 orange. */
export function ratioColor(percent: number): string {
  if (percent > 100) return '#dc2626'
  if (percent < 70) return '#f97316'
  return '#16a34a'
}
